import { Content } from "antd/lib/layout/layout";
import color from "../../resource/color";

interface Props {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  html?: string;
}

function Contrainer({ children, html, style }: Props) {
  if (html) {
    return (
      <Content
        style={{
          paddingTop: "8px",
          paddingRight: "50px",
          paddingLeft: "50px",
          paddingBottom: "8px",
          minHeight: "150px",
          backgroundColor: color.white,
          ...style,
        }}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    );
  }

  return (
    <Content
      style={{
        paddingTop: "8px",
        paddingRight: "50px",
        paddingLeft: "50px",
        paddingBottom: "8px",
        backgroundColor: color.white,
        ...style,
      }}
    >
      {children}
    </Content>
  );
}

export default Contrainer;
